export const emptyModelPrefs = () => ({ disabledProviders: [], disabledModels: [] });

export function isModelEnabled(model, prefs) {
  const provider = String(model?.provider || '').toLowerCase();
  const id = String(model?.id || '');
  if (!id) return false;
  if (prefs.disabledProviders.includes(provider)) return false;
  if (prefs.disabledModels.includes(id)) return false;
  return true;
}

export function applyModelPrefs(models, prefs) {
  if (!Array.isArray(models)) return [];
  return models.filter((m) => isModelEnabled(m, prefs));
}

export function providerLabel(provider) {
  const p = String(provider || '').toLowerCase();
  switch (p) {
    case 'fal':
 return 'fal';
 case 'ada':
      return 'Ada';
    case 'anthropic':
      return 'Anthropic';
    case 'openai':
      return 'OpenAI';
    case 'xai':
      return 'xAI';
    case 'google':
    case 'gemini':
      return 'Google';
    case 'groq':
      return 'Groq';
    case 'opencode':
      return 'OpenCode';
    case 'zai':
      return 'z.ai';
    case 'minimax':
      return 'MiniMax';
    case 'abliteration':
    case 'ablation':
      return 'Abliteration';
    case 'ollama':
      return 'Ollama';
    case 'apodex':
      return 'Apodex';
    case 'auto':
      return 'Auto';
    default:
      return p || 'Other';
  }
}

export function toggleProvider(prefs, provider, models, enabled) {
  const p = String(provider || '').toLowerCase();
  const ids = (models || [])
    .filter((m) => (m.provider || '').toLowerCase() === p)
    .map((m) => m.id);
  const disabledProviders = prefs.disabledProviders.filter((x) => x !== p);
  let disabledModels = prefs.disabledModels.filter((id) => !ids.includes(id));
  if (!enabled) disabledProviders.push(p);
  return { disabledProviders: [...new Set(disabledProviders)], disabledModels: [...new Set(disabledModels)] };
}

export function toggleModel(prefs, model, models, enabled) {
  const id = String(model?.id || '');
  const provider = String(model?.provider || '').toLowerCase();
  let disabledProviders = [...prefs.disabledProviders];
  let disabledModels = prefs.disabledModels.filter((x) => x !== id);

  if (!enabled) {
    disabledProviders = disabledProviders.filter((x) => x !== provider);
    disabledModels.push(id);
    const siblings = (models || []).filter(
      (m) => (m.provider || '').toLowerCase() === provider
    );
    const allOff = siblings.every(
      (m) => m.id === id || disabledModels.includes(m.id)
    );
    if (allOff && siblings.length) {
      disabledProviders.push(provider);
      disabledModels = disabledModels.filter(
        (x) => !siblings.some((m) => m.id === x)
      );
    }
  } else if (disabledProviders.includes(provider)) {
    disabledProviders = disabledProviders.filter((x) => x !== provider);
    const siblings = (models || []).filter(
      (m) => (m.provider || '').toLowerCase() === provider && m.id !== id
    );
    disabledModels.push(...siblings.map((m) => m.id));
  }

  return { disabledProviders: [...new Set(disabledProviders)], disabledModels: [...new Set(disabledModels)] };
}
